module.exports = __webpack_public_path__ + "img/bear.8521f56a.png";